import React from 'react';
import { Link } from "react-router-dom";
import Carousel from "../Carousel";
import { useTranslation } from 'react-i18next';

function HomePageCarousel({ title, desc, items, block }) {
    const { t } = useTranslation();

    if (items.length < 3) { return null; }

    return (
        <>
            <hr />
            <div>
                <h2 className="title is-2">{title}</h2>
                {/* <div className="carousel">
                    <button onClick={() => console.log('move left')}><i className="fa fa-solid fa-arrow-left"></i></button>
                    <button onClick={() => console.log('move right')}><i className="fa fa-solid fa-arrow-right"></i></button>
                </div> */}
                <div className="columns">
                    <div className="column is-3">
                        <p>{desc}</p>
                        {block === 'agents' ?
                            <Link className="button is-link is-small mt-5" to="browse-agents">
                                {t("MORE")}
                            </Link>
                            :
                            <Link className="button is-link is-small mt-5" to="browse-trips">
                                {t("MORE")}
                            </Link>}

                    </div>
                    <div className="column is-9">
                        <Carousel items={items} block={block} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default HomePageCarousel